import "./Contact.module.css";
import { useEffect } from "react";
import Header from "@/reusable_sections/Header";
import ReachTheLab from "./sections/ReachTheLab";
import Map from "./sections/Map";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  useEffect(() => {
    // Set meta description for SEO
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Schedule a confidential consultation with Blue Phoenix Ventures. No obligation. NDA-protected process. Respond within 24 hours. Newport Beach, CA.';
  }, []);
  return <div>
      <Header />
      <h1 className="text-4xl font-bold text-center py-8">Schedule a Confidential M&A Consultation</h1>
      <ReachTheLab />
      <Map />
      <Footer />
    </div>;
}